@if (labelName) {
  <label class="form-label d-block text-truncate" [for]="id">
    {{ labelName }}
    @if (required) {
      <span class="ml-1 fs-6">*</span>
    }
  </label>
}
<ng-select
           [class.ng-disabled]="disabled || readonly"
           [items]="items"
           [labelForId]="id"
           [searchable]="searchable"
           [searchFn]="customSearchFn"
           [editableSearchTerm]="editableSearchTerm"
           [readonly]="readonly || disabled || control.disabled"
           [placeholder]="readonly ? ('noData' | translate) : placeholder"
           [multiple]="multiple"
           [clearable]="clearable"
           [hideSelected]="hideSelected"
           [bindValue]="bindValue"
           [bindLabel]="bindLabel"
           [notFoundText]="notFoundText"
           [title]="getTitle()"
           [id]="id"
           [formControl]="control"
           [class.is-invalid]="control.invalid && control.touched"
           [loadingText]="loadingText"
           (change)="onChangeSelect($event)"
           (blur)="onTouched()"
           (search)="onSearch($event)"
           (clear)="onClear()"
           (remove)="onRemove($event)"
           [virtualScroll]="scrollable"
           [loading]="loading"
           (scrollToEnd)="onScroll($event)"
           (add)="onAdd($event)"
           (open)="onOpen()"
>
  <ng-template ng-label-tmp let-item="item">
  <span class="ng-value-label selected-truncate" [title]="item[bindLabel]">
    {{ item[bindLabel] }}
  </span>
  </ng-template>

  <ng-template ng-option-tmp let-item="item">
    <div class="ng-value-label multiline-option" [title]="item[bindLabel]">
      {{ item[bindLabel] }}
    </div>
  </ng-template>

  @if (preventRemoveLastItem) {
    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      @for (item of items; track item; let i = $index) {
        <div class="ng-value">
          <span
            class="ng-value-icon left"
            (click)="!isLastItem(item) && clear(item)"
            [class.unremovable]="isLastItem(item)"
            aria-hidden="true"
          >
            ×
          </span>
          <span class="ng-value-label truncate-text">{{ item[bindLabel] }}</span>
        </div>
      }
    </ng-template>
  }
</ng-select>

@if (control.invalid && control.touched && !this.disabled && !this.readonly) {
  <div class="invalid-feedback">
    {{ getErrorMessage() }}
  </div>
}
